import React, { useEffect, useState } from 'react'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { PdfFooter, getViewLimitUsagesCol, getViewLimitUsagesColForPDFExcel, getViewLimitUsagesHeaderCol } from './constant'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import { backGroundColorForStatus, isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import { connect } from 'react-redux'
import { getCreditUsageData, getOwnChildBranches } from '../../../../../store/reports/reports_action'
import { GetRequest, PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
const ViewLimitUses = (props) => {
    const { translations } = useTranslation()
    const rdcn = translations?.rechargeDebitCreditNote || {}
    const cs = translations?.common || {}
    const viewLimitUsagesCol = getViewLimitUsagesCol(translations)
    const viewLimitUsagesColForPDFExcel = getViewLimitUsagesColForPDFExcel(translations)
    const viewLimitUsagesHeaderCol = getViewLimitUsagesHeaderCol(translations)
    const theme = useTheme()
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const { setViewLimit, data, getOwnChildBranches, getCreditUsageData } = props
    const { common, reports } = data
    const { loginData, roleRights } = common
    const { ownChildBranches1, reportBranchList, creditUsageReportData } = reports
    const { generatePDF, load } = { ...state }
    const [showTable, setShowTable] = useState(true)
    const [sourceCityList, setSourceCityList] = useState([])
    const [selSourceCity, setSelSourceCity] = useState([])
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [tableData, setTableData] = useState([])
    const [resBranchCity, setResBranchCity] = useState([])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: loginData?.intUserID,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData)
            //   setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
        }
    }, [loginData])
    useEffect(() => {
        const data = creditUsageReportData?.map((val, index) => ({ ...val, SN: index + 1 }))
        setTableData(data)
    }, [creditUsageReportData])
     useEffect(() => {
        if (resBranchCity?.length > 0) {
          const branches = resBranchCity?.map(record => ({
            BranchID: record.BranchID,
            BranchName: record.BranchName,
            CityID: record.CityID,
            CityName: record.CityName,
          }));
          const cities = resBranchCity?.map(record => ({
            CityID: record.CityID,
            CityName: record.CityName,
          }));
          const cityList = removeDuplicatesFromArray(cities, 'CityID')
          const branchList = removeDuplicatesFromArray(branches, 'BranchID')
          setSourceCityList([{ CityName: rdcn.allOption || 'All', CityID: 0 }, ...cityList])
          setSourceBranchList([{ BranchName: rdcn.allOption || 'All', BranchID: 0 }, ...branchList])
        }
    
      }, [resBranchCity])
      useEffect(() => {
        const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
        if (loginCity?.length > 0) {
          setSelSourceCity(loginCity[0])
        } else {
          setSelSourceCity(sourceCityList[0])
        }
      }, [sourceCityList])
    
      useEffect(() => {
        const loginBranch = sourceBranchList?.filter((val) => val?.BranchID === loginData?.intBranchID)
        if (loginBranch?.length > 0) {
          setSelSourceBranch(loginBranch[0])
        } else {
          setSelSourceBranch(sourceBranchList[0])
        }
      }, [sourceBranchList])
      useEffect(() => {
        if (!isEmpty(roleRights)) {
          if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
            const obj = {
              intUserID: 0,
              intCompanyID: loginData?.intCompanyID,
              intBranchID: 0,
              strBranchName: '',
              strBranchCode: '',
              intStateID: 0,
              intCityID: 0,
              intIsActive: -1,
            }
            PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
              if (res.status === 'Success') {
                setResBranchCity(res?.Data?.Table)
              }
            })
            // getBranchConfigOrEwbillinfo(obj)
            // setSourceBranchList(citywiseBranchList)
          } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
            const obj = {
              CompanyID: loginData?.intCompanyID,
              CityID: loginData?.intCityID,
              UserID: loginData?.intUserID,
              BranchID: loginData?.intBranchID,
              Mode: 1,
            }
            GetRequest(urls.getReportBranchList, obj).then((res) => {
              if (res.status == 'Success') {
                setResBranchCity(res?.Data?.Table)
              }
            })
            // getReportBranchList(obj)
            // setSourceBranchList(reportBranchList)
          } else {
            const obj = {
              intUserID: 0,
              intCompanyID: loginData?.intCompanyID,
              intBranchID: 0,
              strBranchName: '',
              strBranchCode: '',
              intStateID: 0,
              intCityID: loginData?.intCityID,
              intIsActive: -1,
            }
            PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
              if (res.status === 'Success') {
                setResBranchCity(res?.Data?.Table)
              }
            })
            // getBranchConfigOrEwbillinfo(obj)
            // setSourceBranchList(citywiseBranchList)
          }
        }
      }, [roleRights, loginData])
   
    const handleClick = () => {
        // setIsExpanded(true)
        const obj = {
            CompanyID: loginData?.intCompanyID,
            UserID: loginData?.intUserID,
            BranchID: selSourceBranch?.BranchID,
            CityID: selSourceCity?.CityID,
            StateID: 0,
        }
        getCreditUsageData(obj)
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <>
                <TableRow style={{ verticalAlign: 'top' }}>
                    <>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}
                        >
                            {item.SN}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.CompanyID}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.CompanyName}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.BranchCode}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.BranchName}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.CityName}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{
                                fontSize: '12px',
                                background: 'F5FAFE',
                                fontWeight: '500',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                                //color: typeof item.CreditLimit === 'number' ? 'red' : item.CreditLimit === 'Unlimited' ? 'green' : '#444',
                                color: item.CreditLimitType === 'Unlimited' ? 'green' : item.CreditLimitType === 'No Credit Limit' ? '' : 'red',
                            }}
                        >
                            {item.CreditLimitType}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.CreditLimit}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.LimitUsage}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.LimitUsageInPer}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.CargoBalance}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', color: item.Status === 'Active' ? '#3C763C' : '#F05924', fontWeight: 'bold' }}
                            title={item.Status}
                        >
                            <span
                                className="status"
                                style={{
                                    backgroundColor: backGroundColorForStatus[`${item.Status}`],
                                    padding: '5px 10px 5px 10px',
                                    borderRadius: '12px',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {item.Status}
                            </span>
                        </TableCell>
                    </>
                </TableRow>
            </>
        )
    }
    const printClick = (isSave) => {
        setShowTable(false)
        setState({ ...state, load: true, generatePDF: true })
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

        const pdfColumns = viewLimitUsagesColForPDFExcel.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderColumns = viewLimitUsagesHeaderCol.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderData = [
            {
                company: loginData?.strCompanyName,
                city: selSourceCity?.CityName,
                branch: selSourceBranch?.BranchName,
            },
        ]
        const doc = new jsPDF({ orientation: 'P', format: [1156, 1636], unit: 'px', compress: true })
        var totalPagesExp = '{total_pages_count_string}'
        doc.setProperties({
            title: `${rdcn.viewLimitUsagesFilename || 'VIEW LIMIT USAGES'}.pdf`,
            subject: rdcn.viewLimitUsagesFilename || 'VIEW LIMIT USAGES',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        })
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            columnStyles: {
                0: {
                    fontSize: 18,
                    valign: 'middle',
                    font: 'Roboto',
                    fontStyle: 'normal',
                    cellPadding: 12,
                    minCellHeight: 36,
                    halign: 'left',
                    textColor: [0, 0, 0],
                },
                1: {
                    fontSize: 18,
                    valign: 'middle',
                    font: 'Roboto',
                    fontStyle: 'normal',
                    cellPadding: 12,
                    minCellHeight: 36,
                    halign: 'left',
                    textColor: [0, 0, 0],
                },
                2: {
                    fontSize: 18,
                    valign: 'middle',
                    font: 'Roboto',
                    fontStyle: 'normal',
                    cellPadding: 12,
                    minCellHeight: 36,
                    halign: 'left',
                    textColor: [0, 0, 0],
                },
                3: {
                    fontSize: 18,
                    valign: 'middle',
                    font: 'Roboto',
                    fontStyle: 'normal',
                    cellPadding: 12,
                    minCellHeight: 36,
                    halign: 'left',
                    textColor: [0, 0, 0],
                },
            },
            theme: 'grid',
            startY: 120,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                // doc.text(
                //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
                //   data.settings.margin.left,
                //   150
                // )
                // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
            },
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: 16,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
                textColor: [0, 0, 0],
            },
            tableLineWidth: 0.6,
            columns: pdfColumns,
            body: tableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2],
            },
            //---------------data of table-----------
            columnStyles: {
                0: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                1: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                2: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                3: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                4: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                5: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                6: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                7: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                8: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                9: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                10: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                11: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
            },
            theme: 'grid',
            // didParseCell: (data) => {
            //     crdeitDrawCellDetail(data)
            // },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(26).setFont('Roboto', 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text(rdcn.cargoSystemViewLimitUsages || 'Cargo System | View Limit Usages', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont('Roboto', 'bold')
                doc.text(`${cs.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
                PdfFooter(data, loginData, totalPagesExp, translations)
            },
            // showHead: 'never',
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`${rdcn.viewLimitUsagesFilename || 'VIEW LIMIT USAGES'} ${new Date().getTime()}.pdf`)
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                document.getElementById('branchRechargeHistoryViewLimitUses').data = doc.output('datauristring', ` ${rdcn.viewLimitUsagesFilename || 'VIEW LIMIT USAGES'}.pdf`)
                // focusElemnt('backBtn')
            }, 2000)
        } else {
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                document.getElementById('branchRechargeHistoryViewLimitUses').data = doc.output('datauristring', ` ${rdcn.viewLimitUsagesFilename || 'VIEW LIMIT USAGES'}.pdf`)
                // focusElemnt('backBtn')
            }, 2000)
        }
    }
    const clickElement = (elementID) => {
        elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
    }
    const selectedCity = (val) => {
        setSelSourceCity(val)
        if (val.CityID === 0) {
          setSelSourceBranch(sourceBranchList[0]);
        }else{
          let result = resBranchCity?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.BranchID === 0)
          setSourceBranchList([{BranchID: 0,BranchName: rdcn.allOption || 'All'},...result])
          setSelSourceBranch(sourceBranchList[0]);
        }
      }
    return (
        <>
            <Item sx={{ padding: '0' }} >
                <Box sx={sx.reportFlex} className='reportButton'>
                    {
                        showTable ? (<>

                            <Item sx={sx.itemsx}>
                                <DropDownOA
                                    id={'selectCompany'}
                                    label={rdcn.selectCompany || 'Select Company'}
                                    defaultvalue={loginData.strCompanyName}
                                    disabled={true}
                                    minWidth="250px"
                                    width="300px"
                                />
                            </Item>
                            <Item sx={sx.itemsx}>
                                <DropDownOA
                                    id={'branchCity'}
                                    label={(rdcn.branchCity || 'Branch City').replace('\n', ' ')}
                                    data={sourceCityList}
                                    defaultvalue={selSourceCity?.CityName}
                                    idKey={`CityID`}
                                    dataKey={`CityName`}
                                    onSelect={(val) => {
                                        selectedCity(val)
                                    }}
                                    isObjArr={true}
                                    searchPlaceholder={rdcn.searchByBranchCity || 'Search By Branch City'}
                                    width="230px"
                                // nextId={id.srcBranch}
                                // prevId={id.stateId}
                                // resetFlag={resetFlag || resetCity}
                                // disabled={disableBtn}
                                />
                            </Item>
                            <Item sx={sx.itemsx}>
                                <DropDownOA
                                    id={'srcBranch'}
                                    label={(rdcn.branchName || 'Branch Name').replace('\n', ' ')}
                                    data={sourceBranchList}
                                    defaultvalue={selSourceBranch?.BranchName}
                                    idKey={`BranchID`}
                                    dataKey={`BranchName`}
                                    onSelect={(val) => {
                                        // setIsExpanded(false)
                                        setSelSourceBranch(val)
                                    }}
                                    isObjArr={true}
                                    searchPlaceholder={rdcn.searchByBranchName || 'Search By Branch Name'}
                                    width="300px"
                                // nextId={id.creditUsageSplitButton}
                                // prevId={id.srcCity}
                                // resetFlag={resetFlag || resetCity}
                                // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                                />
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper" style={{ padding: '0px' }}>
                                <Button variant="contained" style={{ ...sx.fullHeight, ...sx.novp, fontSize: '16px' }} className="btn btn-primary" onClick={handleClick}>
                                    {rdcn.loadUpper || 'LOAD'}
                                </Button>
                            </Item>
                            <Item className="disabled-wrapper" style={{ padding: '0px' }} >
                                <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%', fontSize: '16px' }} className="receiveitembtn"
                                    onClick={() => printClick(false)}
                                // onKeyDown={(e) => {
                                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                // }}
                                >
                                    {rdcn.printUpper || 'PRINT'}
                                </Button>
                            </Item>
                            <Box >
                                <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                                    onClick={(e) => { clickElement('xls-buttons') }}
                                // onKeyDown={(e) => {
                                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                // }}
                                >
                                    {rdcn.excel || 'EXCEL'}
                                </Button>
                                <ReactHtmlTableToExcel
                                    id="xls-buttons"
                                    table="tables"
                                    filename={rdcn.viewLimitUsagesFilename || 'VIEW LIMIT USAGES'}
                                    sheet="sheet 1"
                                    buttonText={rdcn.exportAsExcel || 'EXPORT AS EXCEL'}
                                    className="excel-button"
                                />
                            </Box>
                            <Item className="disabled-wrapper" style={{ padding: '0px' }}>
                                <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%', fontSize: '16px' }} className="receiveitembtn"
                                    onClick={() => setViewLimit(false)}
                                // onKeyDown={(e) => {
                                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                // }}
                                >
                                    {`${rdcn.backTo || 'BACK TO'} ${rdcn.branchRecharge || 'BRANCH RECHARGE'}`}
                                </Button>
                            </Item>
                        </>) : (<>
                            <Box>
                                <Button
                                    style={{ border: '1px solid #fe5200', color: '#fe5200' }}
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => (setShowTable(true))}
                                >
                                    {cs.back || 'Back'}
                                </Button>
                            </Box>
                        </>)
                    }
                    {
                        showTable ? (<>
                            <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
                                <Table id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
                                    <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                                            {viewLimitUsagesCol?.map((item, i) =>
                                                <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF",fontSize:'12px',whiteSpace:'nowrap' }}>{item?.headerName}</TableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    {tableData?.length < 1 ? (
                                        <>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={15}>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                marginTop: '20px',
                                                                marginBottom: '20px',
                                                                color: 'red',
                                                                fontSize: '12px',
                                                                lineheight: '16px',
                                                                letterspacing: '0.24px',
                                                            }}
                                                        >
                                                            <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </>
                                    ) : tableData?.length >= 1 ? (
                                        <TableBody
                                            className="filter-data-row"
                                            style={{
                                                textAlign: 'center',
                                                fontSize: '12px',
                                                lineheight: '16px',
                                                letterspacing: '0.24px',
                                                fontWeight: '500',
                                                marginLeft: '5px',
                                            }}
                                        >
                                            {tableData?.map((item, index) => (
                                                <InsideRowContent item={item} index={index} key={index} />
                                            ))}
                                        </TableBody>
                                    ) : (
                                        ''
                                    )}
                                </Table>
                            </TableContainer>
                        </>) : (
                            <>
                                {generatePDF ? <div style={{ textAlign: 'center' }} className={'generatePDF'}>{cs.pdfGenerationMsg || 'Generating PDF....'}</div> : ''}
                                {load ? (
                                    <object
                                        id="branchRechargeHistoryViewLimitUses"
                                        type="application/pdf"
                                        width={'100%'}
                                        height="440"
                                        title="MTLPL -Cargo System - After Transfer Summary Report"
                                        aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                                        style={{ marginTop: '10px', textAlign: 'center' }}
                                    ></object>
                                ) : (
                                    ''
                                )}
                            </>
                        )
                    }
                </Box>
            </Item>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getOwnChildBranches,
    getCreditUsageData
}
export default connect(mapStateToProps, mapDispatchToProps)(ViewLimitUses)
